<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title">{{ $t(titlePage) }}</h1></CCol
                >
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="5" sm="12">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.answers.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <!-- Data table -->
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'answers',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <ButtonBack class="mr-3" />
                                <TableSettings
                                    :allFields="tables.answers.allFields"
                                    :activeFields.sync="tables.answers.fields"
                                />
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.answers.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.answers.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.answers.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.answers.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.answers.rows"
                                    v-bind="tables.answers"
                                >
                                    <template #id="{ index }">
                                        <td>{{ index + 1 }}</td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    '/campaings.api/providers/' +
                                                    provider +
                                                    '/answers/' +
                                                    answer +
                                                    '/history'
                                                "
                                                :table="tables.answers"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.answers.total_pages > 0">
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.answers.page"
                                        :pages="tables.answers.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.answers.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'answers',
                    })
                "
            >
                <template #title> Create you first Campaing </template>
                <template #description>
                    {{
                        $t(
                            "create_and_configure_all_fields_and_data_destination_for_any_type_of_campaign_you_want_to_activate"
                        )
                    }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('add_new_campaign')"
                        @click="
                            $router.push({
                                name: 'view_campaign',
                                params: {
                                    uuid: tables.answers.itemSelected.uuid,
                                },
                            })
                        "
                    >
                        {{ $t("create_my_first_campaign!") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'answers',
                            })
                        "
                        @click="cleanFiltersAdvance('answers'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonCreate from "~/components/ButtonCreate";
import ButtonExport from "~/components/ButtonExport";
import TableSettings from "£lement/TableSettings";
import ChartGauge from "£lement/ChartGauge";
import NoItemsContainer from "~/components/NoItemsContainer";
import { CChartLine } from "@coreui/vue-chartjs";
import ButtonBack from "£lement/ButtonBack";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import { cilPlus, cilSettings, cilBullhorn } from "@coreui/icons";
import { mapGetters } from "vuex";
import AnswerValuesTable from "./config/tables/AnswerValuesTable";
import { eraser } from "~/assets/icons/js/eraser";

export default {
    name: "AnswersPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        FilterFields,
        CChartLine,
        ChartGauge,
        TableSettings,
        ButtonCreate,
        ButtonExport,
        NoItemsContainer,
        ButtonBack,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilBullhorn,
        eraser,
    },
    data() {
        return {
            tables: {
                answers: AnswerValuesTable,
            },
        };
    },
    computed: {
        provider: function () {
            return this.$route.params.provider;
        },
        answer: function () {
            return this.$route.params.answer;
        },
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.answers.rows = newValue;
            this.updatePagination(this.tables.answers.page);
        },
        updatePagination(newValue) {
            this.tables.answers.page = newValue;
            this.updateData();
        },

        async updateData() {
            await this.updateTable({
                tableName: "answers",
                url: `/campaings.api/providers/${this.provider}/answers/${this.answer}/history`,
            });
            this.tables.answers.itemSelected = null;

            this.loadLanguageInTable({
                tableName: "answers",
                fielLanguageName: "language_id",
            });
            this.loadCountryInTable({
                tableName: "answers",
                fielCountryName: "country_id",
            });

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
    },
    mounted() {
        this.updateData();
    },
    created() {
        this.loadLanguages();
        this.loadCountries();
    },
};
</script>

<style scoped lang="scss">
</style>
